import { AfterViewInit, Directive, ElementRef, Input, Renderer2, SimpleChanges } from '@angular/core';
import { WindowService } from '../window.service';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appCustomDateRangePicker]'
})
export class CustomDateRangePickerDirective implements AfterViewInit {

  @Input() displayMonthsValue: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayMonthsValue) {
      // we use the setTimeout function because the debounceTime operator for detect resize from parent component 
      setTimeout(() => {this.customDateRangePicker()}, 200)
    }
  }

  monthNameStyles = {
    'color': 'var(--dark-blue-color-3, #344054)',
    'text-align': '16px',
    'font-size': 'var(--font-standar, 16px)',
    'font-weight': 'var(--font-weight-semi-medium, 600)',
  };

  weekdaysStyles = {
    'border': '0',
    'margin-bottom': '16px'
  };

  weekdayStyles = {
    'color': 'var(--dark-blue-color-3, #344054)',
    'font-size': 'var(--font-small, 14px)',
    'font-style': 'normal',
  };
  
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private windowService: WindowService
  ) {}

  ngAfterViewInit() {
    this.customDateRangePicker();
  }

  private createNewIconNavigation(button, iconPath, deg) {
    this.renderer.removeClass(button, 'ngb-dp-navigation-chevron');
    this.renderer.setProperty(button, 'innerText', '');
    const img = this.renderer.createElement('img');
    this.renderer.setAttribute(img, 'src', iconPath);
    this.renderer.setStyle(img, 'transform', deg);
    this.renderer.setStyle(button, 'width', '15px');
    this.renderer.setStyle(button, 'height', '15px');
    this.renderer.appendChild(button, img);
  }

  customDateRangePicker() {
    const header = this.el.nativeElement.querySelector('.ngb-dp-header');
    this.renderer.removeClass(header, 'bg-light');

    const navigationChevronList = this.el.nativeElement.querySelectorAll('.ngb-dp-navigation-chevron');
    
    if (navigationChevronList.length > 0) {
      this.renderer.addClass(navigationChevronList[0], 'previous-month');
      this.createNewIconNavigation(navigationChevronList[0], '../../assets/arrow-icon.svg', 'rotate(180deg)');
    }

    if (navigationChevronList.length > 1) {
      this.renderer.addClass(navigationChevronList[navigationChevronList.length - 1], 'next-month');
      this.createNewIconNavigation(navigationChevronList[navigationChevronList.length - 1], '../../assets/arrow-icon.svg', 'rotate(0deg)');
    }

    const weekdaysList = this.el.nativeElement.querySelectorAll('.ngb-dp-weekdays');
    weekdaysList.forEach(weekdays => {
      this.renderer.removeClass(weekdays, 'bg-light');
      this.setStyles(weekdays, this.weekdaysStyles)
    });

    const weekdayList = this.el.nativeElement.querySelectorAll('.ngb-dp-weekday');
    weekdayList.forEach(weekday => {
      this.setStyles(weekday, this.weekdayStyles)
    });

    const monthNameList = this.el.nativeElement.querySelectorAll('.ngb-dp-month-name');
    monthNameList.forEach(monthName => {
      this.setStyles(monthName, this.monthNameStyles)
    }); 
  }

  setStyles(element: ElementRef, styles: Record<string, string>): void {
    for (const [property, value] of Object.entries(styles)) {
      this.renderer.setStyle(element, property, value);
    }
  }

}
